<div
  *ngIf="show"
  class="meeting-modal-backdrop"
  (mousedown)="backdropClicked($event)"
>
  <section
    #dialogPanel
    class="meeting-modal"
    [class.meeting-modal--maximized]="maximized"
    [class.meeting-modal--compact-interview]="compactInterviewMode"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="titleId"
    [attr.aria-busy]="loading || saving"
  >
    <header class="meeting-modal__header">
      <div class="meeting-modal__identity">
        <span class="meeting-modal__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <rect x="3" y="5" width="18" height="16" rx="1"></rect>
            <path d="M7 3v4M17 3v4M3 10h18M8 14h3M8 17h6"></path>
          </svg>
        </span>
        <div class="meeting-modal__heading">
          <span class="meeting-modal__eyebrow">AGENDA CORPORATIVA</span>
          <h2 [id]="titleId">{{ modalHeading }}</h2>
          <p *ngIf="contextLabel">{{ contextLabel }}</p>
        </div>
      </div>

      <div class="meeting-modal__header-actions">
        <button
          type="button"
          class="meeting-icon-button"
          (click)="toggleMaximized()"
          [attr.aria-label]="maximized ? 'Restaurar tamaño' : 'Maximizar ventana'"
          [title]="maximized ? 'Restaurar tamaño' : 'Maximizar'"
        >
          <svg *ngIf="!maximized" viewBox="0 0 24 24">
            <path d="M8 3H3v5M16 3h5v5M21 16v5h-5M8 21H3v-5"></path>
          </svg>
          <svg *ngIf="maximized" viewBox="0 0 24 24">
            <path d="M8 3v5H3M16 3v5h5M21 16h-5v5M3 16h5v5"></path>
          </svg>
        </button>
        <button
          data-modal-close
          type="button"
          class="meeting-icon-button meeting-icon-button--close"
          (click)="requestClose()"
          aria-label="Cerrar ventana de reunión"
          title="Cerrar"
        >
          <svg viewBox="0 0 24 24">
            <path d="m6 6 12 12M18 6 6 18"></path>
          </svg>
        </button>
      </div>
    </header>

    <div class="meeting-modal__statusbar">
      <div class="meeting-status-group">
        <span
          class="meeting-status"
          [attr.data-status]="isRescheduleOnly ? 'EXPIRED' : currentMeeting?.status || 'DRAFT'"
        >
          <span class="meeting-status__dot"></span>
          {{ isRescheduleOnly ? 'Expirada · reprogramar' : statusLabel(currentMeeting?.status) }}
        </span>
        <span
          *ngIf="currentMeeting"
          class="meeting-status"
          [attr.data-status]="currentMeeting.sync_status"
          [title]="currentMeeting.sync_error || ''"
        >
          <span class="meeting-status__dot"></span>
          {{ syncStatusLabel(currentMeeting.sync_status) }}
        </span>
      </div>
      <span class="meeting-modal__reference" *ngIf="currentMeeting?.external_id">
        ID {{ currentMeeting?.external_id | slice: 0 : 8 }}
      </span>
    </div>

    <div *ngIf="loading" class="meeting-state meeting-state--fill" aria-live="polite">
      <span class="meeting-spinner" aria-hidden="true"></span>
      <strong>Cargando reunión</strong>
      <span>Consultando la información más reciente.</span>
    </div>

    <form
      *ngIf="!loading"
      class="meeting-modal__form"
      [formGroup]="form"
      (ngSubmit)="submit()"
      novalidate
    >
      <main class="meeting-modal__content">
        <div
          *ngIf="errorMessage"
          class="meeting-alert meeting-alert--error"
          role="alert"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="9"></circle>
            <path d="M12 7.5v5.5M12 17h.01"></path>
          </svg>
          <div>
            <strong>No se pudo completar la operación</strong>
            <span>{{ errorMessage }}</span>
          </div>
          <button
            *ngIf="conflictExternalId"
            type="button"
            class="meeting-link-button"
            (click)="openExistingConflict()"
          >
            Abrir reunión existente
          </button>
        </div>

        <div
          *ngIf="currentMeeting?.sync_status === 'ERROR'"
          class="meeting-alert meeting-alert--warning"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 3 2.7 20h18.6zM12 9v4M12 17h.01"></path>
          </svg>
          <div>
            <strong>Microsoft no confirmó la sincronización</strong>
            <span>{{ currentMeeting?.sync_error || 'Puede reintentar sin duplicar la reunión.' }}</span>
          </div>
          <button
            *ngIf="currentMeeting?.permissions?.can_manage"
            type="button"
            class="meeting-link-button"
            [disabled]="saving"
            (click)="retrySync()"
          >
            Reintentar
          </button>
        </div>

        <div
          *ngIf="currentMeeting && !currentMeeting.permissions?.can_manage"
          class="meeting-alert meeting-alert--info"
          role="status"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 12s3.5-6 9-6 9 6 9 6-3.5 6-9 6-9-6-9-6Z"></path>
            <circle cx="12" cy="12" r="2.5"></circle>
          </svg>
          <div>
            <strong>Participas en esta reunión</strong>
            <span>Está disponible en modo consulta. Solo quien creó la reunión puede editarla, reprogramarla o cancelarla; tú sí puedes registrar tu propia asistencia.</span>
          </div>
        </div>

        <div
          *ngIf="attendanceMessage"
          class="meeting-alert meeting-alert--info"
          role="status"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="9"></circle>
            <path d="M12 10v6M12 7h.01"></path>
          </svg>
          <div>
            <strong>Asistencia de Microsoft Teams</strong>
            <span>{{ attendanceMessage }}</span>
          </div>
        </div>

        <div
          *ngIf="isRescheduleOnly"
          class="meeting-alert meeting-alert--warning"
          role="status"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="9"></circle>
            <path d="M12 7v5l3 2M8 3 5 0"></path>
          </svg>
          <div>
            <strong>Esta reunión ya expiró</strong>
            <span>Solo puedes modificar el inicio, la finalización y la zona horaria para volver a programarla.</span>
          </div>
        </div>

        <div class="meeting-modal__workspace">
          <div class="meeting-modal__primary-column">
            <section class="meeting-section meeting-section--primary">
          <div class="meeting-section__header">
            <div>
              <span class="meeting-section__eyebrow">INFORMACIÓN GENERAL</span>
              <h3>Datos de la reunión</h3>
            </div>
            <span class="meeting-required-hint" *ngIf="canEditMeetingDetails">
              <b>*</b> Campos obligatorios
            </span>
          </div>

          <div class="meeting-form-grid">
            <label class="meeting-field meeting-field--full">
              <span class="meeting-field__label">Asunto <b>*</b></span>
              <input
                data-initial-focus
                type="text"
                formControlName="subject"
                maxlength="255"
                placeholder="Ej. Entrevista técnica — Analista de software"
              />
              <small
                class="meeting-field__error"
                *ngIf="form.get('subject')?.touched && form.get('subject')?.invalid"
              >
                Ingrese un asunto de máximo 255 caracteres.
              </small>
            </label>

            <div
              *ngIf="!compactInterviewMode"
              class="meeting-planning-strip meeting-field--full"
            >
              <label class="meeting-planning-toggle">
                <input
                  type="checkbox"
                  formControlName="is_all_day"
                  (change)="onAllDayChanged()"
                />
                <span>
                  <b>Todo el día</b>
                  <small>Oculta horas y reserva el día completo.</small>
                </span>
              </label>

              <div class="meeting-planning-series">
                <span class="meeting-field__label">Tipo</span>
                <div class="meeting-segmented">
                  <button
                    type="button"
                    [class.is-active]="!isRecurring"
                    (click)="setRecurrenceEnabled(false)"
                  >
                    Evento
                  </button>
                  <button
                    type="button"
                    [class.is-active]="isRecurring"
                    (click)="setRecurrenceEnabled(true)"
                  >
                    Serie
                  </button>
                </div>
              </div>

              <label class="meeting-planning-field">
                <span class="meeting-field__label">Recordar</span>
                <select formControlName="reminder_minutes">
                  <option
                    *ngFor="let option of reminderOptions"
                    [ngValue]="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>
              </label>

              <label class="meeting-planning-field">
                <span class="meeting-field__label">Categoría</span>
                <select formControlName="category">
                  <option
                    *ngFor="let category of categoryOptions"
                    [value]="category"
                  >
                    {{ category }}
                  </option>
                </select>
              </label>

              <div class="meeting-planning-state">
                <span class="meeting-field__label">Estado</span>
                <strong>
                  {{
                    isRescheduleOnly
                      ? 'Expirada'
                      : statusLabel(currentMeeting?.status)
                  }}
                </strong>
              </div>
            </div>

            <div
              *ngIf="!compactInterviewMode && isRecurring"
              class="meeting-series-config meeting-field--full"
            >
              <label class="meeting-planning-field">
                <span class="meeting-field__label">Repetir</span>
                <select formControlName="recurrence_frequency">
                  <option
                    *ngFor="let option of recurrenceOptions"
                    [value]="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>
              </label>

              <label class="meeting-planning-field">
                <span class="meeting-field__label">Cada</span>
                <div class="meeting-inline-number">
                  <input
                    type="number"
                    min="1"
                    max="99"
                    formControlName="recurrence_interval"
                  />
                  <span>
                    {{
                      form.get('recurrence_frequency')?.value === 'DAILY'
                        ? 'día(s)'
                        : form.get('recurrence_frequency')?.value === 'MONTHLY'
                          ? 'mes(es)'
                          : 'semana(s)'
                    }}
                  </span>
                </div>
              </label>

              <label class="meeting-planning-field">
                <span class="meeting-field__label">Hasta</span>
                <input type="date" formControlName="recurrence_end_date" />
              </label>

              <p>
                La serie se sincronizará con Microsoft y podrá gestionarse desde
                la misma agenda de ZIVO.
              </p>
            </div>

            <label *ngIf="!compactInterviewMode" class="meeting-field">
              <span class="meeting-field__label">Modalidad <b>*</b></span>
              <select formControlName="meeting_type" (change)="onMeetingTypeChanged()">
                <option *ngFor="let option of meetingTypes" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </label>

            <label *ngIf="!compactInterviewMode" class="meeting-field">
              <span class="meeting-field__label">Proveedor <b>*</b></span>
              <select formControlName="provider">
                <option *ngFor="let option of providers" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
              <small *ngIf="configurationLoading">Verificando proveedores disponibles…</small>
              <small
                *ngIf="activeMode === 'create' && configuration.microsoft?.configured && configuration.microsoft?.canCreateMeetings === false"
              >Los eventos de Outlook y las reuniones de Teams solo pueden crearse con una cuenta organizadora &#64;novax.ec.</small>
            </label>

            <label *ngIf="compactInterviewMode" class="meeting-field meeting-field--teams">
              <span class="meeting-field__label">Microsoft Teams</span>
              <span class="meeting-teams-toggle">
                <input
                  type="checkbox"
                  [checked]="form.get('provider')?.value === 'MICROSOFT_TEAMS'"
                  (change)="setTeamsEnabled($any($event.target).checked)"
                />
                <span>Crear vínculo de Teams</span>
              </span>
            </label>

            <label
              *ngIf="compactInterviewMode || !isAllDay"
              class="meeting-field"
            >
              <span class="meeting-field__label">
                {{ compactInterviewMode ? "Fecha y hora" : "Inicio" }} <b>*</b>
              </span>
              <input
                type="datetime-local"
                formControlName="start_at"
                (change)="onCompactInterviewStartChanged()"
              />
            </label>

            <label
              *ngIf="!compactInterviewMode && !isAllDay"
              class="meeting-field"
            >
              <span class="meeting-field__label">Finalización <b>*</b></span>
              <input type="datetime-local" formControlName="end_at" />
            </label>

            <label
              *ngIf="!compactInterviewMode && isAllDay"
              class="meeting-field meeting-field--full meeting-all-day-date"
            >
              <span class="meeting-field__label">Fecha del evento <b>*</b></span>
              <input type="date" formControlName="all_day_date" />
              <small>Se reservará el día completo, sin horario específico.</small>
            </label>

            <label *ngIf="!compactInterviewMode" class="meeting-field">
              <span class="meeting-field__label">Zona horaria <b>*</b></span>
              <select formControlName="timezone">
                <option
                  *ngFor="let timezone of configuration.timezones"
                  [value]="timezone.value"
                >
                  {{ timezone.label }}
                </option>
              </select>
            </label>

            <label *ngIf="!compactInterviewMode" class="meeting-field">
              <span class="meeting-field__label">
                Organizador
              </span>
              <select *ngIf="hasOrganizerOptions" formControlName="organizer_user_external_id">
                <option [ngValue]="null">Utilizar usuario actual</option>
                <option *ngFor="let organizer of organizerOptions" [ngValue]="organizer.external_id">
                  {{ organizer.label }}{{ organizer.email ? ' — ' + organizer.email : '' }}
                </option>
              </select>
              <input
                *ngIf="!hasOrganizerOptions"
                type="text"
                value="Usuario autenticado"
                readonly
                aria-label="Se utilizará el usuario autenticado como organizador"
              />
              <small>Si queda vacío, se utilizará el usuario autenticado.</small>
            </label>

            <label *ngIf="!compactInterviewMode" class="meeting-field meeting-field--full">
              <span class="meeting-field__label">
                Ubicación
                <b *ngIf="form.get('meeting_type')?.value === 'PRESENTIAL'">*</b>
              </span>
              <input
                type="text"
                formControlName="location"
                placeholder="Sala, dirección o referencia de conexión"
              />
            </label>

            <label
              *ngIf="compactInterviewMode"
              class="meeting-field meeting-field--full meeting-description"
            >
              <span class="meeting-field__label">Observaciones</span>
              <textarea
                formControlName="description"
                rows="4"
                placeholder="Observaciones o indicaciones para la entrevista"
              ></textarea>
            </label>

            <div
              *ngIf="!compactInterviewMode"
              class="meeting-field meeting-field--full meeting-description"
            >
              <div class="meeting-description__topline">
                <span class="meeting-field__label">Descripción</span>
                <div class="meeting-segmented" *ngIf="canEditMeetingDetails">
                  <button
                    type="button"
                    [class.is-active]="descriptionType === 'TEXT'"
                    (click)="setDescriptionType('TEXT')"
                  >
                    Texto normal
                  </button>
                  <button
                    type="button"
                    [class.is-active]="descriptionType === 'HTML'"
                    (click)="setDescriptionType('HTML')"
                  >
                    HTML seguro
                  </button>
                </div>
              </div>

              <div
                *ngIf="descriptionType === 'HTML' && canEditMeetingDetails"
                class="meeting-editor-toolbar"
                aria-label="Formato básico de la descripción"
              >
                <button type="button" (click)="insertHtml('<strong>', '</strong>')" title="Negrita"><b>B</b></button>
                <button type="button" (click)="insertHtml('<em>', '</em>')" title="Cursiva"><i>I</i></button>
                <button type="button" (click)="insertHtml('<ul><li>', '</li></ul>')" title="Lista">• Lista</button>
                <button type="button" (click)="insertHtml('<p>', '</p>')" title="Párrafo">¶</button>
                <button
                  type="button"
                  class="meeting-editor-toolbar__preview"
                  [class.is-active]="showDescriptionPreview"
                  (click)="toggleDescriptionPreview()"
                >
                  {{ showDescriptionPreview ? 'Editar' : 'Vista previa' }}
                </button>
              </div>

              <textarea
                #descriptionEditor
                *ngIf="!showDescriptionPreview && canEditMeetingDetails"
                formControlName="description"
                rows="10"
                [placeholder]="descriptionType === 'HTML' ? 'Escriba el contenido o utilice formato HTML básico…' : 'Escriba las instrucciones o agenda de la reunión…'"
              ></textarea>

              <div
                *ngIf="(showDescriptionPreview || !canEditMeetingDetails) && descriptionType === 'HTML'"
                class="meeting-description__preview"
                [innerHTML]="descriptionPreview"
              ></div>
              <div
                *ngIf="!canEditMeetingDetails && descriptionType === 'TEXT'"
                class="meeting-description__preview meeting-description__preview--text"
              >
                {{ form.get('description')?.value || 'Sin descripción.' }}
              </div>
              <small *ngIf="descriptionType === 'HTML' && canEditMeetingDetails">
                El contenido se sanitiza antes de enviarlo y al mostrar la vista previa.
              </small>
            </div>
          </div>
            </section>

            <section
              *ngIf="compactInterviewMode"
              class="meeting-section meeting-section--compact-link"
              aria-label="Vínculo de la entrevista"
            >
              <span class="meeting-field__label">Vínculo de reunión</span>
              <div class="meeting-compact-link">
                <input
                  type="text"
                  readonly
                  [value]="displayJoinUrl || 'Se generará al guardar la reunión'"
                />
                <button
                  type="button"
                  [disabled]="!displayJoinUrl"
                  (click)="copyJoinUrl()"
                  [title]="joinUrlCopied ? 'Vínculo copiado' : 'Copiar vínculo'"
                  aria-label="Copiar vínculo"
                >
                  <svg viewBox="0 0 24 24"><path d="M8 8h11v11H8zM5 16H4V5h11v1"></path></svg>
                </button>
                <button
                  type="button"
                  [disabled]="!safeJoinUrl"
                  (click)="openJoinUrl()"
                  title="Abrir vínculo"
                  aria-label="Abrir vínculo"
                >
                  <svg viewBox="0 0 24 24"><path d="M14 5h5v5M12 12l7-7M19 13v6H5V5h6"></path></svg>
                </button>
              </div>
            </section>
          </div>

          <aside class="meeting-modal__secondary-column">
            <section class="meeting-section meeting-section--participants">
          <div class="meeting-section__header">
            <div>
              <span class="meeting-section__eyebrow">INVITACIONES</span>
              <h3>Participantes</h3>
              <p>{{ participants.length }} persona{{ participants.length === 1 ? '' : 's' }} en la invitación</p>
            </div>
            <button
              *ngIf="canEditMeetingDetails"
              type="button"
              class="meeting-button meeting-button--secondary meeting-button--small"
              (click)="addParticipant()"
              title="Agregar persona externa"
              aria-label="Agregar persona externa"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"></path></svg>
              <span *ngIf="!compactInterviewMode">Invitado externo</span>
            </button>
          </div>

          <div *ngIf="canEditMeetingDetails" class="meeting-user-search">
            <div class="meeting-user-search__heading">
              <div>
                <span class="meeting-field__label">Buscar usuario de ZIVO</span>
                <small>Se completarán automáticamente el nombre, correo y vínculo interno.</small>
              </div>
              <span class="meeting-user-search__source">DIRECTORIO INTERNO</span>
            </div>
            <div class="meeting-user-search__control">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="11" cy="11" r="6"></circle>
                <path d="m16 16 4 4"></path>
              </svg>
              <input
                type="search"
                [(ngModel)]="userSearch"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onUserSearchChanged($event)"
                (focus)="openUserSearch()"
                (blur)="closeUserSearch()"
                placeholder="Nombre, apellido, cédula o correo…"
                autocomplete="off"
                role="combobox"
                aria-label="Buscar usuario de ZIVO para agregarlo a la reunión"
                [attr.aria-expanded]="userSearchOpen && userSearch.trim().length >= 2"
              />
              <span *ngIf="searchingUsers" class="meeting-user-search__spinner" aria-hidden="true"></span>
            </div>

            <div
              *ngIf="userSearchOpen && userSearch.trim().length >= 2"
              class="meeting-user-search__results"
              role="listbox"
            >
              <div *ngIf="searchingUsers" class="meeting-user-search__state">
                Buscando usuarios…
              </div>
              <div *ngIf="!searchingUsers && userSearchError" class="meeting-user-search__state meeting-user-search__state--error">
                {{ userSearchError }}
              </div>
              <div
                *ngIf="!searchingUsers && !userSearchError && userSearchResults.length === 0"
                class="meeting-user-search__state"
              >
                No se encontraron usuarios activos.
              </div>
              <button
                *ngFor="let user of userSearchResults"
                type="button"
                class="meeting-user-search__option"
                role="option"
                [disabled]="!!basicUserDisabledReason(user)"
                [title]="basicUserDisabledReason(user) || 'Agregar a la reunión'"
                (mousedown)="$event.preventDefault()"
                (click)="selectBasicUser(user)"
              >
                <span class="meeting-user-search__avatar" aria-hidden="true">
                  {{ (user.nombre || '?') | slice: 0 : 1 }}{{ (user.apellidos || '') | slice: 0 : 1 }}
                </span>
                <span class="meeting-user-search__identity">
                  <strong>{{ user.nombre }} {{ user.apellidos }}</strong>
                  <small>{{ user.correo || 'Sin correo' }} · {{ user.cedula || 'Sin cédula' }}</small>
                </span>
                <span class="meeting-user-search__action">
                  {{ basicUserDisabledReason(user) || 'Agregar' }}
                </span>
              </button>
            </div>
          </div>

          <div *ngIf="participantError" class="meeting-inline-error" role="alert">
            {{ participantError }}
          </div>

          <div
            *ngIf="participants.length === 0"
            class="meeting-empty-state"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M16 19v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 17.5V19M10 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6M17 8v6M14 11h6"></path>
            </svg>
            <strong>Aún no hay participantes</strong>
            <span>Puede guardar la reunión sin invitados o agregarlos ahora.</span>
          </div>

          <div class="meeting-participant-list" formArrayName="participants">
            <article
              *ngFor="let participant of participants.controls; let index = index; trackBy: participantTrackBy"
              class="meeting-participant"
              [class.meeting-participant--locked]="isParticipantLocked(index)"
              [formGroupName]="index"
            >
              <div class="meeting-participant__number" aria-hidden="true">
                {{ index + 1 }}
              </div>
              <div class="meeting-participant__fields">
                <label class="meeting-field">
                  <span class="meeting-field__label">Nombre</span>
                  <input
                    type="text"
                    formControlName="name"
                    [readonly]="isParticipantLocked(index)"
                    placeholder="Nombre completo"
                  />
                </label>
                <label class="meeting-field">
                  <span class="meeting-field__label">Correo <b>*</b></span>
                  <input
                    type="email"
                    formControlName="email"
                    [readonly]="isParticipantLocked(index)"
                    placeholder="persona@empresa.com"
                  />
                  <small
                    class="meeting-field__error"
                    *ngIf="participant.get('email')?.touched && participant.get('email')?.invalid"
                  >Correo inválido.</small>
                </label>
                <label *ngIf="!compactInterviewMode" class="meeting-field">
                  <span class="meeting-field__label">Rol</span>
                  <select
                    formControlName="participant_role"
                    [attr.disabled]="isParticipantRoleLocked(index) ? true : null"
                  >
                    <option
                      *ngFor="let role of participantRoleOptionsFor(index)"
                      [value]="role.value"
                    >{{ role.label }}</option>
                  </select>
                </label>
                <label *ngIf="!compactInterviewMode" class="meeting-field">
                  <span class="meeting-field__label">Asistencia</span>
                  <select
                    formControlName="attendance_type"
                    [attr.disabled]="isParticipantLocked(index) ? true : null"
                  >
                    <option value="REQUIRED">Obligatoria</option>
                    <option value="OPTIONAL">Opcional</option>
                    <option value="RESOURCE">Recurso</option>
                  </select>
                </label>
              </div>
              <div class="meeting-participant__aside">
                <span
                  *ngIf="participant.get('response_status')?.value"
                  class="meeting-response-badge"
                  title="Respuesta a la invitación; no confirma asistencia real"
                >
                  Invitación: {{ responseStatusLabel(participant.get('response_status')?.value) }}
                </span>
                <span *ngIf="isParticipantLocked(index)" class="meeting-lock-badge" title="Participante requerido por el proceso">
                  Fijo
                </span>
                <button
                  *ngIf="canEditMeetingDetails && !isParticipantLocked(index)"
                  type="button"
                  class="meeting-remove-button"
                  (click)="removeParticipant(index)"
                  aria-label="Eliminar participante"
                  title="Eliminar participante"
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5"></path></svg>
                </button>
              </div>

              <div
                *ngIf="currentMeeting"
                class="meeting-participant__attendance"
                [attr.data-attendance]="participant.get('attendance_status')?.value || 'NOT_AVAILABLE'"
              >
                <div class="meeting-participant__attendance-state">
                  <span class="meeting-attendance-dot" aria-hidden="true"></span>
                  <strong>
                    {{ attendanceStatusLabel(participant.get('attendance_status')?.value) }}
                  </strong>
                </div>
                <div
                  *ngIf="participant.get('attendance_status')?.value === 'PRESENT'"
                  class="meeting-participant__attendance-metrics"
                >
                  <span>
                    <b>Ingresó</b>
                    {{ formatAttendanceDate(participant.get('first_joined_at')?.value) }}
                  </span>
                  <span>
                    <b>Salió</b>
                    {{ formatAttendanceDate(participant.get('last_left_at')?.value) }}
                  </span>
                  <span>
                    <b>Duración</b>
                    {{ formatAttendanceDuration(participant.get('total_attendance_seconds')?.value) }}
                  </span>
                </div>
                <small *ngIf="participant.get('attendance_status')?.value === 'ABSENT'">
                  No se registró asistencia para esta persona.
                </small>
                <small *ngIf="participant.get('attendance_status')?.value === 'NOT_AVAILABLE'">
                  Se podrá consultar cuando Teams publique el reporte al finalizar.
                </small>
                <div
                  *ngIf="canRegisterParticipantAttendance(index)"
                  class="meeting-participant__attendance-actions"
                  aria-label="Registrar asistencia"
                >
                  <button
                    type="button"
                    class="meeting-attendance-action meeting-attendance-action--present"
                    [class.is-active]="participant.get('attendance_status')?.value === 'PRESENT'"
                    [disabled]="isParticipantAttendanceUpdating(index)"
                    (click)="registerParticipantAttendance(index, 'PRESENT')"
                    title="Confirmar que esta persona asistió"
                  >
                    <svg viewBox="0 0 24 24"><path d="m5 12 4 4L19 6"></path></svg>
                    Asistió
                  </button>
                  <button
                    type="button"
                    class="meeting-attendance-action meeting-attendance-action--absent"
                    [class.is-active]="participant.get('attendance_status')?.value === 'ABSENT'"
                    [disabled]="isParticipantAttendanceUpdating(index)"
                    (click)="registerParticipantAttendance(index, 'ABSENT')"
                    title="Registrar que esta persona no asistió"
                  >
                    <svg viewBox="0 0 24 24"><path d="m7 7 10 10M17 7 7 17"></path></svg>
                    No asistió
                  </button>
                </div>
              </div>
            </article>
          </div>
            </section>

            <section
              *ngIf="currentMeeting && !compactInterviewMode"
              class="meeting-section meeting-section--summary"
            >
          <div class="meeting-section__header">
            <div>
              <span class="meeting-section__eyebrow">INTEGRACIÓN</span>
              <h3>Información de conexión</h3>
            </div>
            <button
              *ngIf="canSyncAttendance"
              type="button"
              class="meeting-button meeting-button--secondary meeting-button--small"
              [disabled]="attendanceLoading"
              (click)="syncAttendance()"
              title="Teams publica este reporte después de que termina la reunión"
            >
              <span *ngIf="attendanceLoading" class="meeting-button-spinner" aria-hidden="true"></span>
              <svg *ngIf="!attendanceLoading" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M20 6v5h-5M4 18v-5h5M6.1 9a7 7 0 0 1 11.5-2.4L20 11M4 13l2.4 4.4A7 7 0 0 0 17.9 15"></path>
              </svg>
              {{ currentMeeting.attendance_sync_status === 'SYNCED' ? 'Actualizar' : 'Consultar asistencia' }}
            </button>
          </div>
          <div class="meeting-integration-grid">
            <div>
              <span>Organizador original</span>
              <strong>{{ originalOrganizerEmail || 'Correo no disponible' }}</strong>
            </div>
            <div>
              <span>Estado del proveedor</span>
              <strong>{{ syncStatusLabel(currentMeeting.sync_status) }}</strong>
            </div>
            <div>
              <span>Reprogramaciones</span>
              <strong>{{ currentMeeting.reschedule_count || 0 }}</strong>
            </div>
            <div>
              <span>Asistencia real</span>
              <strong>{{ attendanceSyncLabel }}</strong>
              <small *ngIf="currentMeeting.attendance_last_synced_at">
                {{ formatAttendanceDate(currentMeeting.attendance_last_synced_at) }}
              </small>
            </div>
            <div class="meeting-integration-grid__link">
              <span>Acceso a la reunión</span>
              <button
                *ngIf="safeJoinUrl; else noJoinUrl"
                type="button"
                class="meeting-join-button"
                (click)="openJoinUrl()"
              >
                <svg viewBox="0 0 24 24"><path d="M14 5h5v5M12 12l7-7M19 13v6H5V5h6"></path></svg>
                Abrir reunión
              </button>
              <ng-template #noJoinUrl>
                <strong *ngIf="currentMeeting.status === 'CANCELLED'" class="meeting-link-state meeting-link-state--cancelled">
                  Vínculo cancelado e inhabilitado
                </strong>
                <strong *ngIf="currentMeeting.status !== 'CANCELLED' && isRescheduleOnly" class="meeting-link-state meeting-link-state--expired">
                  Vínculo expirado; reprograma la reunión para habilitarlo
                </strong>
                <strong *ngIf="currentMeeting.status === 'COMPLETED'" class="meeting-link-state">
                  Reunión finalizada; vínculo inhabilitado
                </strong>
                <strong *ngIf="currentMeeting.status === 'SCHEDULED' && !isRescheduleOnly">
                  Enlace aún no disponible
                </strong>
              </ng-template>
            </div>
          </div>
            </section>
          </aside>
        </div>
      </main>

      <footer class="meeting-modal__footer">
        <p>
          <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 10v6M12 7h.01"></path></svg>
          {{ isReadOnly
            ? 'La información se muestra en modo consulta.'
            : isRescheduleOnly
              ? 'Al reprogramar se actualizará la invitación de los participantes.'
              : 'Los invitados recibirán la actualización cuando Microsoft confirme la sincronización.' }}
        </p>
        <div class="meeting-modal__footer-actions">
          <button
            *ngIf="canDeleteMeeting"
            type="button"
            class="meeting-button meeting-button--danger"
            (click)="requestLifecycleAction('delete')"
          >
            {{ isSeries ? 'Eliminar serie' : 'Eliminar evento' }}
          </button>
          <button
            *ngIf="canCancelMeeting"
            type="button"
            class="meeting-button meeting-button--danger-outline"
            (click)="requestLifecycleAction('cancel')"
          >
            {{ isSeries ? 'Cancelar serie' : 'Cancelar reunión' }}
          </button>
          <button
            *ngIf="canCompleteMeeting"
            type="button"
            class="meeting-button meeting-button--success"
            (click)="requestLifecycleAction('complete')"
          >
            Completar
          </button>
          <button
            type="button"
            class="meeting-button meeting-button--secondary"
            (click)="requestClose()"
          >
            {{ isReadOnly ? 'Cerrar' : 'Cancelar' }}
          </button>
          <button
            *ngIf="!isReadOnly && !isMeetingClosed && !isSeriesExpired"
            type="submit"
            class="meeting-button meeting-button--primary"
            [disabled]="saving"
          >
            <span *ngIf="saving" class="meeting-button-spinner" aria-hidden="true"></span>
            <svg *ngIf="!saving" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M5 12.5 9.2 17 19 7"></path>
            </svg>
            {{ saving ? 'Guardando…' : submitLabel }}
          </button>
        </div>
      </footer>
    </form>

    <div *ngIf="confirmingClose" class="meeting-confirm-overlay" role="alertdialog" aria-modal="true">
      <div class="meeting-confirm">
        <span class="meeting-confirm__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M12 3 2.7 20h18.6zM12 9v4M12 17h.01"></path></svg>
        </span>
        <h3>¿Descartar los cambios?</h3>
        <p>La información que no haya guardado se perderá.</p>
        <div>
          <button type="button" class="meeting-button meeting-button--secondary" (click)="continueEditing()">Continuar editando</button>
          <button type="button" class="meeting-button meeting-button--danger" (click)="discardAndClose()">Descartar y cerrar</button>
        </div>
      </div>
    </div>

    <div *ngIf="lifecycleAction" class="meeting-confirm-overlay" role="alertdialog" aria-modal="true">
      <div class="meeting-confirm meeting-confirm--lifecycle">
        <span class="meeting-confirm__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M12 3 2.7 20h18.6zM12 9v4M12 17h.01"></path></svg>
        </span>
        <h3>{{ lifecycleTitle }}</h3>
        <p>{{ lifecycleDescription }}</p>
        <label *ngIf="lifecycleAction === 'cancel'" class="meeting-field meeting-confirm__reason">
          <span class="meeting-field__label">Motivo de cancelación</span>
          <textarea
            rows="3"
            [(ngModel)]="cancellationReason"
            [ngModelOptions]="{ standalone: true }"
            maxlength="500"
            placeholder="Explique brevemente el motivo (opcional)"
          ></textarea>
        </label>
        <div>
          <button type="button" class="meeting-button meeting-button--secondary" [disabled]="saving" (click)="cancelLifecycleAction()">Volver</button>
          <button
            type="button"
            class="meeting-button"
            [class.meeting-button--danger]="lifecycleAction === 'cancel' || lifecycleAction === 'delete'"
            [class.meeting-button--success]="lifecycleAction === 'complete'"
            [disabled]="saving"
            (click)="confirmLifecycleAction()"
          >
            {{ saving ? 'Procesando…' : lifecycleConfirmLabel }}
          </button>
        </div>
      </div>
    </div>
  </section>
</div>
